import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hovered", "sort"];
import styled from 'foundations-theming/utils';
import { omitProps } from '../../../utils/Props';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { Clickable } from '../../Clickable';
import { CSS_SPECIFICITY } from '../../../constants/CSSSpecificity';
import { getFocusStyleObject } from '../../../utils/focus/focus.style';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledSortTH_TH = styled(omitProps(Clickable, ['hovered', 'sort']))(({
  theme,
  $hovered,
  $sort,
  $cssStyles
}) => {
  return Object.assign({
    [CSS_SPECIFICITY.OVERRIDE]: Object.assign({
      cursor: 'pointer',
      userSelect: 'none'
    }, $hovered && {
      backgroundColor: theme.color['temp-future-fill-field-hover']
    }, $sort !== 'none' && {
      backgroundColor: theme.color['temp-future-fill-field-pressed']
    })
  }, getFocusStyleObject({
    theme
  }), $cssStyles);
});
export const SortTH_TH = _ref => {
  let {
      hovered,
      sort
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    callbackProps,
    restProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledSortTH_TH, Object.assign({
    tagName: "th",
    role: "button",
    tabIndex: 0
  }, domProps, callbackProps, restProps, {
    $hovered: hovered,
    $sort: sort,
    $cssStyles: cssStyles
  }));
};